import React from "react";
import {Result} from "antd";

const PageNotFound: React.FC = () => {
    return (
        <Result
            status="404"
            title="404"
            subTitle="访问的页面不存在"
        />
    );
}

export default PageNotFound;